<!-- ╔══════════════════════════════════════════════════════════╗ -->
<!-- ║  DOT Leads™  ·  Search Overlay  ·  Design System v2     ║ -->
<!-- ╚══════════════════════════════════════════════════════════╝ -->

<div class="search-overlay" *ngIf="is_visible" [@overlayAnim]>
  <!-- Blurred backdrop -->
  <div class="search-overlay__backdrop"></div>

  <!-- Main card -->
  <div class="search-overlay__card">
    <!-- Rainbow accent bar -->
    <div class="search-overlay__accent"></div>

    <!-- Animated truck + radar rings -->
    <div class="search-overlay__visual">
      <!-- Radar rings radiating outward -->
      <div class="radar">
        <div class="radar__ring radar__ring--1"></div>
        <div class="radar__ring radar__ring--2"></div>
        <div class="radar__ring radar__ring--3"></div>
        <!-- Rotating sweep line -->
        <div class="radar__sweep"></div>
        <!-- Center icon -->
        <div class="radar__core">
          <i class="pi pi-truck"></i>
        </div>
      </div>
    </div>

    <!-- Status text -->
    <div class="search-overlay__body">
      <div class="search-overlay__title">{{ message }}</div>
      <div class="search-overlay__sub">
        Scanning FMCSA Intelligence Database
      </div>

      <!-- Animated progress bar -->
      <div class="search-overlay__bar-wrap">
        <div class="search-overlay__bar"></div>
      </div>

      <!-- Live counter tickers -->
    </div>
  </div>
</div>
